import cn from 'classnames'

import { Translation } from 'cng-common/features/translations/components/translation'

import stylesCompensation from '../../../Compensation.module.scss'
import stylesTable from '../../../PartnerDevicesInfo.module.scss'

import tr from './translations'

import styles from './RegionalDistributorWarning.module.scss'

interface IProps {
  isRegionalPlanning: boolean
}

export const RegionalDistributorWarning = ({ isRegionalPlanning }: IProps) => {
  const regionalDistributorTranslationKey = isRegionalPlanning
    ? tr.distributorRegionalPlanningInfo
    : tr.distributorGroupPlanningIFnfo

  return (
    <div className={styles.root}>
      <table className={cn(stylesTable.table, stylesCompensation.table)}>
        <caption>
          <div className={cn(styles.infoContainer)}>
            <i className={cn('kbase kbase-warning-alt', styles.infoIcon)} aria-hidden="true" />
            <Translation text={regionalDistributorTranslationKey} actionsInside />
          </div>
        </caption>
      </table>
    </div>
  )
}
